export const notificaciones = {
  slug: "gestionar-notificaciones-email",
  title: "Cómo gestionar las notificaciones por email",
  image: "https://images.unsplash.com/photo-1596526131083-e8c633c948d2?w=800&q=80",
  excerpt: "Aprende a configurar las notificaciones de tus alertas según tus preferencias.",
  content: (
    <>
      <h2>Gestiona tus notificaciones por email</h2>
      <p>En eRastro queremos que tengas el control total sobre cómo recibes las notificaciones de tus alertas. Sabemos que a veces prefieres revisar los productos encontrados cuando tú decidas, sin recibir correos electrónicos constantemente.</p>

      <p>Por eso, hemos incluido una opción que te permite desactivar las notificaciones por email mientras tus alertas siguen funcionando normalmente en segundo plano.</p>

      <h2>¿Cómo funciona?</h2>
      <p>Cuando desactivas las notificaciones por correo electrónico:</p>

      <ul>
        <li><strong>Tus alertas siguen activas:</strong> El sistema continúa buscando productos que coincidan con tus criterios</li>
        <li><strong>Los productos se guardan:</strong> Todos los productos encontrados se almacenan en tu sección de alertas</li>
        <li><strong>Sin emails:</strong> No recibirás correos electrónicos cuando haya nuevos productos</li>
        <li><strong>Tú decides cuándo revisar:</strong> Puedes entrar a la plataforma cuando quieras y ver todos los productos nuevos acumulados</li>
      </ul>

      <h2>¿Cómo desactivar las notificaciones por email?</h2>
      <p>Desactivar las notificaciones es muy sencillo. Sigue estos pasos:</p>

      <ol>
        <li>Inicia sesión en tu cuenta de eRastro</li>
        <li>Ve a tu perfil de usuario haciendo clic en tu nombre o avatar en la esquina superior derecha</li>
        <li>Haz clic en <strong>"Configuración de Cuenta"</strong></li>
        <li>Busca la opción <strong>"Recibir mail con alertas"</strong></li>
        <li>Desmarca el checkbox para desactivar las notificaciones</li>
        <li>Los cambios se guardan automáticamente</li>
      </ol>

      <img src="/imgs/config-notificaciones.png" alt="Configuración de notificaciones"/>

      <h2>¿Qué pasa cuando desactivo las notificaciones?</h2>
      <p>Una vez desactivadas las notificaciones por email:</p>

      <h3>Lo que sigue funcionando:</h3>
      <ul>
        <li>✅ Todas tus alertas continúan rastreando productos</li>
        <li>✅ Los productos encontrados aparecen en la sección "Mis Alertas"</li>
        <li>✅ Puedes ver el contador de productos nuevos en cada alerta</li>
        <li>✅ El rastreador de productos sigue monitoreando cambios de precio</li>
        <li>✅ Toda la funcionalidad de la plataforma permanece activa</li>
      </ul>

      <h3>Lo que cambia:</h3>
      <ul>
        <li>❌ No recibirás emails cuando se encuentren nuevos productos</li>
        <li>❌ No recibirás emails cuando haya cambios de precio en productos rastreados</li>
      </ul>

      
      <h2>¿Cuándo es recomendable desactivar las notificaciones?</h2>
      <p>Desactivar las notificaciones por email es ideal si:</p>

      <ul>
        <li><strong>Tienes muchas alertas activas:</strong> Si has configurado muchas alertas, podrías recibir demasiados emails</li>
        <li><strong>Prefieres revisar a tu ritmo:</strong> Si te gusta entrar a la plataforma en momentos específicos del día</li>
        <li><strong>Quieres evitar saturación:</strong> Si tu bandeja de entrada ya recibe muchos correos</li>
        <li><strong>Solo buscas ocasionalmente:</strong> Si no tienes prisa y prefieres revisar productos de vez en cuando</li>
      </ul>

      <h2>¿Cuándo mantener las notificaciones activas?</h2>
      <p>Te recomendamos mantener las notificaciones por email si:</p>

      <ul>
        <li><strong>Buscas algo específico urgentemente:</strong> Si necesitas encontrar un producto pronto</li>
        <li><strong>Tienes pocas alertas:</strong> Si solo tienes 1-3 alertas activas, los emails no serán molestos</li>
        <li><strong>No entras a la plataforma regularmente:</strong> Si prefieres que te avisen para no perder oportunidades</li>
        <li><strong>Los productos se venden rápido:</strong> Si buscas artículos muy demandados que se agotan pronto</li>
      </ul>

      <h2>Reactivar las notificaciones</h2>
      <p>Si cambias de opinión, puedes reactivar las notificaciones en cualquier momento:</p>

      <ol>
        <li>Ve a <strong>"Configuración de la Cuenta"</strong></li>
        <li>Marca el checkbox <strong>"Recibir mail con alertas"</strong></li>
        <li>A partir de ese momento, volverás a recibir emails cuando haya nuevos productos</li>
      </ol>

      <h2>Consejos útiles</h2>

      <h3>Encuentra el equilibrio perfecto</h3>
      <p>Puedes ajustar tus preferencias según tus necesidades:</p>

      <ul>
        <li><strong>Estrategia mixta:</strong> Mantén pocas alertas con notificaciones activas para productos urgentes, y desactiva las notificaciones cuando tengas muchas alertas generales</li>
        <li><strong>Gestión temporal:</strong> Activa las notificaciones cuando busques algo específico y desactívalas cuando solo estés explorando</li>
        <li><strong>Revisa regularmente:</strong> Si desactivas las notificaciones, establece una rutina para revisar tus alertas (por ejemplo, cada mañana o cada tarde)</li>
      </ul>

      <h3>Maximiza tu experiencia</h3>
      <ul>
        <li>Si desactivas las notificaciones, intenta entrar a la plataforma al menos una vez al día para no perder oportunidades</li>
        <li>Usa el buscador dentro de cada alerta para filtrar rápidamente los productos nuevos</li>
        <li>Recuerda que los productos de segunda mano se venden rápido, así que revisa con frecuencia</li>
      </ul>

      <h2>¿Necesitas ayuda?</h2>
      <p>Si tienes problemas para configurar tus notificaciones o tienes alguna pregunta, no dudes en contactarnos a través de la sección de contacto. Estamos aquí para ayudarte a personalizar tu experiencia en eRastro.</p>

      <p><strong>Recuerda: Tú tienes el control. Configura eRastro como mejor te funcione.</strong></p>
    </>
  )
};
